import type { ClientCertificateItem } from '@/types/api/queries';
import type { RefundClientCertificateFormValues } from '@/types/schemas';

import { centsToMoneyFormat } from '@/helpers';

export const certificateItemCounters = (item: ClientCertificateItem) => {
  if (item.kind === 'deposit') {
    return {
      initial: centsToMoneyFormat(item.deposit_initial_cents ?? 0),
      remaining: centsToMoneyFormat(item.deposit_remaining_cents ?? 0),
    };
  }

  return {
    initial: String(item.sellable_initial_count ?? 0),
    remaining: String(item.sellable_remaining_count ?? 0),
  };
};

export const createRefundClientCertificateData = (
  values: RefundClientCertificateFormValues,
) => ({
  refund_target: values.refund_target,
  cash_register_id:
    values.refund_target === 'deposit' ? null : Number(values.cash_register_id),
  refund_reason_id: Number(values.refund_reason_id),
  description: values.description || null,
});
